module.exports = __webpack_public_path__ + "img/undraw_Internet_on_the_go_re_vben.8f1341ab.svg";